import { render, staticRenderFns } from "./SaturationLevers.vue?vue&type=template&id=b487c1c8&scoped=true&"
import script from "./SaturationLevers.vue?vue&type=script&lang=js&"
export * from "./SaturationLevers.vue?vue&type=script&lang=js&"
import style0 from "./SaturationLevers.vue?vue&type=style&index=0&id=b487c1c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b487c1c8",
  null
  
)

export default component.exports